import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';

export default function Content() {
  // 폼 데이터 상태 추가
  const [formData, setFormData] = useState({
    companyName: '',
    name: '',
    tel: '',
    email: '',
    region: '',
    address: '',
    robotType: '',
    robotModel: '',
    content: '',
    privacyAgreed: false,
  });

  // 셀렉트 상태 관리
  const [isRegionOpen, setIsRegionOpen] = useState(false);
  const [isRobotTypeOpen, setIsRobotTypeOpen] = useState(false);
  const [isRobotModelOpen, setIsRobotModelOpen] = useState(false);
  const regionSelectRef = useRef(null);
  const robotTypeSelectRef = useRef(null);
  const robotModelSelectRef = useRef(null);

  const regionOptions = [
    { value: '', label: '선택' },
    { value: 'seoul', label: '서울' },
    { value: 'gyeonggi', label: '경기' },
    { value: 'incheon', label: '인천' },
    { value: 'gangwon', label: '강원' },
    { value: 'chungcheong', label: '충청' },
    { value: 'jeolla', label: '전라' },
    { value: 'gyeongsang', label: '경상' },
    { value: 'jeju', label: '제주' },
  ];

  const robotTypeOptions = [
    { value: '', label: '선택' },
    { value: 'serving', label: '서빙로봇' },
    { value: 'logistics', label: '물류로봇' },
    { value: 'cleaning', label: '청소로봇' },
  ];

  const robotModelOptions = {
    serving: [
      { value: 'T5', label: 'T5' },
      { value: 'T6', label: 'T6' },
      { value: 'T8', label: 'T8' },
      { value: 'T9', label: 'T9' },
      { value: 'T10', label: 'T10' },
      { value: 'T11', label: 'T11' },
      { value: 'W3', label: 'W3' },
    ],
    logistics: [{ value: 'S100', label: 'S100' }],
    cleaning: [
      { value: 'C30', label: 'C30' },
      { value: 'C40', label: 'C40' },
    ],
  };

  const [availableModels, setAvailableModels] = useState([]);

  // 외부 클릭 감지하여 드롭다운 닫기
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        regionSelectRef.current &&
        !regionSelectRef.current.contains(event.target)
      ) {
        setIsRegionOpen(false);
      }
      if (
        robotTypeSelectRef.current &&
        !robotTypeSelectRef.current.contains(event.target)
      ) {
        setIsRobotTypeOpen(false);
      }
      if (
        robotModelSelectRef.current &&
        !robotModelSelectRef.current.contains(event.target)
      ) {
        setIsRobotModelOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // 입력값 변경 핸들러
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // 지역 선택 핸들러
  const handleRegionSelect = (value, label) => {
    setFormData((prev) => ({
      ...prev,
      region: value,
    }));
    setIsRegionOpen(false);
    console.log('선택된 지역:', label);
  };

  // 로봇 유형 선택 핸들러
  const handleRobotTypeSelect = (value, label) => {
    setFormData((prev) => ({
      ...prev,
      robotType: value,
      robotModel: '', // 로봇 유형이 변경되면 모델 초기화
    }));
    setIsRobotTypeOpen(false);
    console.log('선택된 로봇 유형:', label);

    // 로봇 유형에 따른 모델 옵션 설정
    if (value && robotModelOptions[value]) {
      setAvailableModels(robotModelOptions[value]);
    } else {
      setAvailableModels([]);
    }
  };

  // 로봇 모델 선택 핸들러
  const handleRobotModelSelect = (value, label) => {
    setFormData((prev) => ({
      ...prev,
      robotModel: value,
    }));
    setIsRobotModelOpen(false);
    console.log('선택된 로봇 모델:', label);
  };

  // 선택된 옵션의 라벨 가져오기
  const getSelectedLabel = (options, value) => {
    const option = options.find((opt) => opt.value === value);
    return option ? option.label : '';
  };

// 폼 제출 핸들러
  const handleSubmit = async (e) => {
    e.preventDefault();

    // 필수 항목 검증
    if (
      !formData.companyName ||
      !formData.name ||
      !formData.tel ||
      !formData.email
    ) {
      alert('필수 항목을 모두 입력해주세요.');
      return;
    }

    if (!formData.privacyAgreed) {
      alert('개인정보 수집 및 이용에 동의해주세요.');
      return;
    }

    try {
      // 서버로 전송할 데이터 (c_category1: 0 = 제휴문의)
      const submitData = {
        c_company_name: formData.companyName,
        c_name: formData.name,
        c_tel: formData.tel,
        c_email: formData.email,
        c_addr1: formData.region,
        c_addr2: formData.address,
        c_prd: formData.robotType,
        c_prdname: formData.robotModel,
        c_content: formData.content,
        c_category1: 0, // 제휴문의
        c_title: `${formData.companyName} 제휴문의` // 자동 생성된 제목
      };

      console.log('제출된 데이터:', submitData);

      // 백엔드 API 호출
      const response = await axios.post('/api/contact', submitData);

      if (response.data && response.data.success !== false) {
        alert('문의가 성공적으로 제출되었습니다.');
        
        setFormData({
          companyName: '',
          name: '',
          tel: '',
          email: '',
          region: '',
          address: '',
          robotType: '',
          robotModel: '',
          content: '',
          privacyAgreed: false,
        });
        setAvailableModels([]);
      } else {
        alert('문의 제출에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'));
      }

    } catch (error) {
      console.error('전송 오류:', error);
      alert('문의 제출 중 오류가 발생했습니다: ' + (error.response?.data?.message || error.message));
    }
  };



  return (
    <>
      <div className="s5_1_content">
        <div className="center2">
          <form onSubmit={handleSubmit}>
            {/* 문의자정보 섹션 */}
            <div className="row-flex-center between w-100 bd-bottom-de pb-2 mb-5">
              <p className="prt-bold fs-30 fc-black1">문의자정보</p>
              <p className="prt-light fs-16 fc-888">
                <span style={{ color: 'red' }}>*</span> 필수 항목입니다.
              </p>
            </div>

            <div className="row-flex-center flex-wrap txt-left between ">
              <div className="contact_input_wrap">
                <label
                  className="mb-2 prt-medium fs-20 fc-black1"
                  htmlFor="c_name"
                >
                  회사명
                </label>
                <input
                  className="prt-regular fs-18 fc-black1 w-100"
                  type="text"
                  name="companyName"
                  id="c_name"
                  placeholder="회사명을 입력하세요."
                  value={formData.companyName}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="contact_input_wrap">
                <label
                  className="mb-2 prt-medium fs-20 fc-black1"
                  htmlFor="name"
                >
                  이름
                </label>
                <input
                  className="prt-regular fs-18 fc-black1 w-100"
                  type="text"
                  name="name"
                  id="name"
                  placeholder="이름을 입력하세요."
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="contact_input_wrap">
                <label
                  className="mb-2 prt-medium fs-20 fc-black1"
                  htmlFor="tel"
                >
                  연락처
                </label>
                <input
                  className="prt-regular fs-18 fc-black1 w-100"
                  type="tel"
                  name="tel"
                  id="tel"
                  placeholder="연락처를 입력하세요."
                  value={formData.tel}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="contact_input_wrap">
                <label
                  className="mb-2 prt-medium fs-20 fc-black1"
                  htmlFor="email"
                >
                  이메일
                </label>
                <input
                  className="prt-regular fs-18 fc-black1 w-100"
                  type="email"
                  name="email"
                  id="email"
                  placeholder="이메일을 입력하세요."
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              {/* 지역 + 상세주소 */}
              <div className="contact_input_wrap optional">
                <label
                  className="mb-2 prt-medium fs-20 fc-black1"
                  htmlFor="region"
                >
                  지역
                </label>
                <div className="row-flex-center between flex-wrap">
                  {/* 커스텀 지역 셀렉트 */}
                  <div ref={regionSelectRef} className="custom-select mb-1">
                    <div
                      className={`select_trigger prt-regular fs-16 ${
                        isRegionOpen ? 'open' : ''
                      }`}
                      onClick={() => setIsRegionOpen(!isRegionOpen)}
                    >
                      <div className="select_text">
                        {formData.region
                          ? getSelectedLabel(regionOptions, formData.region)
                          : '선택'}
                      </div>
                      <div
                        className={`select_arrow ${
                          isRegionOpen ? 'rotate' : ''
                        }`}
                      >
                        <svg
                          width="12"
                          height="7"
                          viewBox="0 0 12 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L11 1"
                            stroke="#666666"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    {isRegionOpen && (
                      <div className="select_options prt-light fs-16 fc-black1">
                        {regionOptions.map((option) => (
                          <div
                            key={option.value}
                            className={`select_option prt-regular fs-16${
                              formData.region === option.value ? 'selected' : ''
                            }`}
                            onClick={() =>
                              handleRegionSelect(option.value, option.label)
                            }
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <input
                    className="prt-regular fs-18 fc-black1 w-83 mb-1"
                    type="text"
                    name="address"
                    id="address"
                    placeholder="상세주소를 입력하세요."
                    value={formData.address}
                    onChange={handleInputChange}
                  />
                </div>
              </div>
            </div>

            {/* 문의 사항 섹션 */}
            <div className="w-100 bd-bottom-de pb-2 mb-5 mt-5">
              <p className="prt-bold fs-30 fc-black1">문의 사항</p>
            </div>

            {/* 로봇 유형 선택 (옵션1) */}
            <div className="contact_input_wrap contact_input_wrap2 optional w-100">
              <label className="mb-2 prt-medium fs-20 fc-black1">
                문의 항목
              </label>
              <div className="row-flex-center" style={{ position: 'relative' }}>
                {/* 로봇 유형 셀렉트 (옵션1) */}
                <div
                  ref={robotTypeSelectRef}
                  className="custom-select"
                  style={{ width: '15%' }}
                >
                  <div
                    className={`select_trigger prt-regular fs-16 ${
                      isRobotTypeOpen ? 'open' : ''
                    }`}
                    onClick={() => setIsRobotTypeOpen(!isRobotTypeOpen)}
                  >
                    <div className="select_text">
                      {formData.robotType
                        ? getSelectedLabel(robotTypeOptions, formData.robotType)
                        : '선택'}
                    </div>
                    <div
                      className={`select_arrow ${
                        isRobotTypeOpen ? 'rotate' : ''
                      }`}
                    >
                      <svg
                        width="12"
                        height="7"
                        viewBox="0 0 12 7"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1 1L6 6L11 1"
                          stroke="#666666"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  {isRobotTypeOpen && (
                    <div className="select_options prt-regular fs-16">
                      {robotTypeOptions.map((option) => (
                        <div
                          key={option.value}
                          className={`select_option prt-regular fs-16 ${
                            formData.robotType === option.value
                              ? 'selected'
                              : ''
                          }`}
                          onClick={() =>
                            handleRobotTypeSelect(option.value, option.label)
                          }
                        >
                          {option.label}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* 로봇 모델 셀렉트 (옵션2) - 로봇 유형이 선택된 경우에만 표시 */}
                {formData.robotType && (
                  <div
                    ref={robotModelSelectRef}
                    className="custom-select"
                    style={{
                      width: '15%',
                      marginLeft: '20px',
                    }}
                  >
                    <div
                      className={`select_trigger prt-regular fs-16${
                        isRobotModelOpen ? 'open' : ''
                      }`}
                      onClick={() => setIsRobotModelOpen(!isRobotModelOpen)}
                    >
                      <div className="select_text">
                        {formData.robotModel || '선택'}
                      </div>
                      <div
                        className={`select_arrow ${
                          isRobotModelOpen ? 'rotate' : ''
                        }`}
                      >
                        <svg
                          width="12"
                          height="7"
                          viewBox="0 0 12 7"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L11 1"
                            stroke="#666666"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    {isRobotModelOpen && (
                      <div className="select_options prt-regular fs-16">
                        {availableModels.map((option) => (
                          <div
                            key={option.value}
                            className={`select_option prt-regular fs-16 ${
                              formData.robotModel === option.value
                                ? 'selected'
                                : ''
                            }`}
                            onClick={() =>
                              handleRobotModelSelect(option.value, option.label)
                            }
                          >
                            {option.label}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            <div
              className="contact_input_wrap contact_input_wrap2 
            optional w-100"
            >
              <label
                className="mb-2 prt-medium fs-20 fc-black1"
                htmlFor="content"
              >
                문의 내용
              </label>
              <textarea
                className="text_area prt-regular fs-18 fc-black1"
                name="content"
                id="content"
                placeholder="문의하실 내용을 입력해주세요."
                value={formData.content}
                onChange={handleInputChange}
                rows="8"
              />
            </div>

            {/* 개인정보 동의 */}
            <div className="privacy_agreement mb-5">
              <label className="checkbox_label row-flex-center gap-20">
                <input
                  type="checkbox"
                  name="privacyAgreed"
                  checked={formData.privacyAgreed}
                  onChange={handleInputChange}
                  required
                />
                <span className="checkbox_text prt-light fs-16 fc-black1">
                  [필수]{' '}
                  <a href="/privacy" target="_blank" className="link_text">
                    개인정보
                  </a>{' '}
                  수집 및 이용 동의
                </span>
              </label>
            </div>

            {/* 제출 버튼 */}
            <div className="submit_button_wrap txt-center">
              <button
                type="submit"
                className="submit_button prt-medium fs-18"
                disabled={!formData.privacyAgreed}
              >
                문의하기
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
